import React, { PureComponent } from 'react'
import { withTheme } from 'styled-components'

import { Label, LabelBg } from 'atoms/Texts'
import { ButtonReg } from 'atoms/Buttons'
import { FormSelect } from 'atoms/Inputs'
import {
  MainWrapper,
  ModalHead,
  ModalFooter,
  LevelRowContainer,
  StyledDatePicker,
} from './styles'
import BlastingInventory from './BlastingInventory'
import DetailPit from './DetailPit'
import LogHistory from './LogHistory'
import lo from 'lodash'
import moment from 'moment'

export class NewBlastingReportModal extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      pitOptions: [],
    }
    this.formRefs = {}
  }

  isEditingMode() {
    const { blastingReportData } = this.props
    return blastingReportData.hasOwnProperty('createdAt') ? true : false
  }

  isEditAllowed() {
    const { blastingReportData, allowApproval } = this.props
    // data cannot be edited if status is APPROVED and user doesn't have permission to approve
    return blastingReportData.status === "APPROVED" && !allowApproval ? false : true
  }

  componentDidMount(){
    this.fetchPitOptions()
  }

  componentDidUpdate(prevProps) {
    // handle if pit options fail to be fetched when the component is mounted
    if (prevProps.contractorPitLookups !== this.props.contractorPitLookups) {
      this.fetchPitOptions()
    }
  }

  fetchPitOptions() {
    const { contractorPitLookups, blastingReportData } = this.props
    const found = contractorPitLookups.find(el => el.id === parseInt(blastingReportData.contractorId))
    if (found) {
      this.setState({ pitOptions: found.pits})
    }
  }

  handleSubmit() {
    const { blastingReportData, fnSubmit } = this.props

    const newBlastingReportData = lo.cloneDeep(blastingReportData)
    
    newBlastingReportData.drillDate = moment(newBlastingReportData.drillDate).format('YYYY-MM-DD')
    newBlastingReportData.blastingDate = moment(newBlastingReportData.blastingDate).format('YYYY-MM-DD')

    // custom isEmpty function
    const isEmpty = lo.cond([
      [lo.isString, x => lo.isEmpty(x) || lo.isEqual(x, '-') || lo.isEqual(x, '0')],
      [lo.isNumber, x => lo.isEqual(x, 0)],
      [lo.isBoolean, x => false],
      [lo.isArrayLike, lo.isEmpty],
      [lo.isObjectLike, lo.flow(lo.keys, lo.isEmpty)],
      [lo.stubTrue, lo.isEmpty]
    ])

    let message = ""

    // check if there are any empty fields
    const isFieldsEmpty = (obj, id) => {
      // key of fields that are not mandatory
      let excludedKey = ["amoniumNitrate", "detonatorType", "detonatorAmount"]
      for (const key in obj) {
        if (obj.hasOwnProperty(key) && !excludedKey.includes(key)) {
          const value = obj[key]
          if (isEmpty(value)) {
            if (key === 'attachments') {
              message = 'Attachments cannot be empty'
            } else {
              // set focus to empty field
              if (id !== undefined) {
                // access form reference based on 'key' and 'id'
                const formRef = this.formRefs[`${key}_${id}`]
                if (formRef) {
                  // focus on the form reference
                  formRef.focus()
                }
              } else if (obj.hasOwnProperty('id')) {
                // if 'id' is not defined but object has property 'id'
                // access form reference based on 'key' and 'obj.id'
                const formRef = this.formRefs[`${key}_${obj.id}`];
                if (formRef) {
                  formRef.focus()
                }
              }
            }
            return true
          }
        }
      }
      return false
    }

    let allFieldsValid = true
    
    const reportDetails = newBlastingReportData.details
    if (isFieldsEmpty(newBlastingReportData) || isFieldsEmpty(reportDetails)) {
      allFieldsValid = false
    } else {
      reportDetails.detailPit.forEach((pit) => {
        if (isFieldsEmpty(pit) || isFieldsEmpty(pit.pitInfo, pit.id) || isFieldsEmpty(pit.geometri, pit.id) || isFieldsEmpty(pit.explosiveUsage, pit.id)) {
          allFieldsValid = false
          return
        } else {
          pit.explosiveUsage.surfaces.forEach((surface, index) => {
            if (isFieldsEmpty(surface)) {
              allFieldsValid = false
              return
            }
            if (
              surface.surfaceType !== "-" &&
              surface.surfaceLength !== "-" &&
              pit.explosiveUsage.surfaces
                .slice(index + 1)
                .some((otherSurface) => surface.surfaceType === otherSurface.surfaceType && surface.surfaceLength === otherSurface.surfaceLength)
            ) {
              allFieldsValid = false
              message = "Surface Type must not have duplicate type and length data"
              const formRef = this.formRefs[`surfaceType_${surface.id}`]
              if (formRef) {
                formRef.focus()
              }
              return
            }
          })

          pit.explosiveUsage.inholes.forEach((inhole, index) => {
            if (isFieldsEmpty(inhole)) {
              allFieldsValid = false
              return
            }
            if (
              inhole.inholeType !== "-" &&
              inhole.inholeLength !== "-" &&
              pit.explosiveUsage.inholes
                .slice(index + 1)
                .some((otherInhole) => inhole.inholeType === otherInhole.inholeType 
                && inhole.inholeLength === otherInhole.inholeLength)
            ) {
              allFieldsValid = false
              message = "Inhole Type must not have duplicate type and length data"
              const formRef = this.formRefs[`inholeType_${inhole.id}`]
              if (formRef) {
                formRef.focus()
              }
              return
            }
          })

          pit.explosiveUsage.dynamites.forEach((dynamite, index) => {
            if (isFieldsEmpty(dynamite)) {
              allFieldsValid = false
              return
            }
            if (
              dynamite.dynamiteType !== "-" &&
              dynamite.dynamiteWeight !== "-" &&
              pit.explosiveUsage.dynamites
                .slice(index + 1)
                .some((otherDynamite) => dynamite.dynamiteType === otherDynamite.dynamiteType 
                && dynamite.dynamiteWeight === otherDynamite.dynamiteWeight)
            ) {
              allFieldsValid = false
              message = "Dynamite Type must not have duplicate type and weight data"
              const formRef = this.formRefs[`dynamiteType_${dynamite.id}`]
              if (formRef) {
                formRef.focus()
              }
              return
            }
          })
          
          if (allFieldsValid && (parseInt(pit.pitInfo.sectionFrom) > parseInt(pit.pitInfo.sectionTo))) {
            allFieldsValid = false
            message = "Section To must be greater than Section From"
            const formRef = this.formRefs[`sectionFrom_${pit.id}`]
            if (formRef) {
              formRef.focus()
            }
            return
          }
        }
        
      })

      if (allFieldsValid) {
        reportDetails.blastingInventory.forEach((pit, index) => {
          if (isFieldsEmpty(pit)) {
            allFieldsValid = false
            return
          }
          if (
            pit.pit !== "-" &&
            pit.positionType !== "-" &&
            reportDetails.blastingInventory
              .slice(index + 1)
              .some((otherPit) => pit.pit === otherPit.pit && pit.positionType === otherPit.positionType)
          ) {
            allFieldsValid = false
            message = "Blasting Inventory report must not have any pit with identical position type"
            const formRef = this.formRefs[`pit_${pit.id}`]
            if (formRef) {
              formRef.focus()
            }
            return
          }
        })
      }
    }

    if (!allFieldsValid) {
      alert(message ? message : "Fields are mandatory and the value cannot be 0")
    } else {
      // proceed to submit function if all fields valid
      fnSubmit()
    }
  }

  render() {
    const { theme, contractorPitLookups, blastingReportData, isDisabled, fnChange, allowApproval } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
    }

    return (
      <MainWrapper>
        <ModalHead>
          <Label lineheight={'29px'} size={'24px'} mb={'0px'}>
            {this.isEditingMode() ? 'Edit ' : 'Add New '} Blasting Report
          </Label>
        </ModalHead>
        <LevelRowContainer>
          <div className={'row col-12 mx-0 px-0'}>
            <div className={'col-12 px-0 py-2'}>
              <Label lineheight={'21px'} size={'14px'} mb={'0px'} color={'#473A94'}>
                General Info
              </Label>
            </div>
            <div className={'col-6 px-0 pr-2'}>
              <Label lineheight={'14px'} size={'12px'}>
                Drill Date
              </Label>
              <div className={'row mx-0 px-0'}>
                <StyledDatePicker
                  onChange={date => fnChange(date, 'drillDate')}
                  value={blastingReportData.drillDate ? new Date(blastingReportData.drillDate) : new Date()}
                  maxDate={new Date()}
                  disabled={this.isEditingMode() && !this.isEditAllowed()}
                />
              </div>
            </div>
            <div className={'col-6 px-0 pl-2'}>
              <Label lineheight={'14px'} size={'12px'}>
                Blasting Date
              </Label>
              <div className={'row mx-0 px-0'}>
                <StyledDatePicker
                  onChange={date => fnChange(date, 'blastingDate')}
                  value={blastingReportData.blastingDate ? new Date(blastingReportData.blastingDate) : new Date()}
                  maxDate={new Date()}
                  disabled={this.isEditingMode() && !this.isEditAllowed()}
                />
              </div>
            </div>

            <div className={'col-6 px-0 pr-2'}>
              <Label lineheight={'14px'} size={'12px'}>
                Contractor
              </Label>
              <FormSelect
                placeholder={'Select contractor'}
                onChangeVal={e => {
                  fnChange(e.target.value, 'contractorId')
                  this.fetchPitOptions()
                }}
                options={contractorPitLookups}
                value={blastingReportData.contractorId}
                disabled={this.isEditingMode() && !this.isEditAllowed()}
                valField={'id'}
                dispField={'name'}
                arrowSize={'16px'}
                {...inputConfig}
              />
            </div>
            {this.isEditingMode() && 
              <div className={'col-6 px-0 pl-2'}>
                <Label lineheight={'14px'} size={'12px'}>
                  Status
                </Label>
                <div className={'row mx-0 px-0'}>
                  <LabelBg
                    lineheight={'16px'}
                    size={'12px'}
                    bgColor={
                      blastingReportData.status === 'APPROVED'
                        ? theme.mocaGreen
                        : blastingReportData.status === 'SENDBACK'
                        ? theme.mocaRed
                        : theme.mocaOrange
                    }
                    width={'160px'}
                    height={'34px'}
                  >
                    {blastingReportData.status}
                  </LabelBg>
                </div>
              </div>
            }
          </div>
        </LevelRowContainer>
        <div className={'px-2'}>
          <DetailPit {...this.props} isDisabled={this.isEditingMode() && !this.isEditAllowed()} pitOptions={this.state.pitOptions} formRefs={this.formRefs} />
          <BlastingInventory {...this.props} isDisabled={this.isEditingMode() && !this.isEditAllowed()} pitOptions={this.state.pitOptions} formRefs={this.formRefs} />
          {this.isEditingMode() && 
            <LogHistory {...this.props} />
          }
        </div>

        <ModalFooter>
          <ButtonReg
            onClick={this.props.fnSwitch}
            disabled={isDisabled}
            transparent
            bg={theme.unreadRed}
            color={theme.unreadRed}
            bordered
            btnTxt={'Cancel'}
            margin={'0 16px 0 0'}
          />
          {this.isEditingMode() ? (
            this.isEditAllowed() && (
              <>
                <ButtonReg
                  onClick={() => this.handleSubmit()}
                  bg={theme.mocaPurple}
                  btnTxt={'Update'}
                  margin={'0 16px 0 0'}
                />
                {allowApproval && blastingReportData.status !== 'SENDBACK' && (
                  <>
                    <ButtonReg
                      onClick={this.props.fnSendBack}
                      bg={theme.unreadRed}
                      btnTxt={'Send Back'}
                      margin={'0 16px 0 0'}
                    />
                    {blastingReportData.status !== 'APPROVED' && 
                      <ButtonReg
                        onClick={this.props.fnApprove}
                        background={'linear-gradient(90deg, #463191 0%, #C802FF 90.26%)'}
                        btnTxt={'Approve'}
                      />
                    }
                  </>
                )}
              </>
            )
          ) : (
            <ButtonReg
              onClick={() => this.handleSubmit()}
              disabled={isDisabled}
              background={'linear-gradient(90deg, #463191 0%, #C802FF 90.26%)'}
              btnTxt={isDisabled ? 'Submitting...' : 'Submit'}
            />
          )}
        </ModalFooter>

      </MainWrapper>
    )
  }
}

export default withTheme(NewBlastingReportModal)